import Logs from './Logs.page';

export default Logs;
